export enum HighlightType {
  Comment = 'comment',
  Clause = 'clause',
  DocumentInfo = 'documentInfo',
  Source = 'source',
}
